import React from "react";
import { NavLink } from "react-router-dom";
import { Container, Navbar, Nav } from "react-bootstrap";
import { IMAGES } from "../../constants";
import RippleButton from "./RippleButton";

const Header = () => {
  return (
    <Navbar expand="lg" className="onboarding-header" collapseOnSelect>
      <Container fluid className="onboarding-header-container">
        <Nav className="align-items-center justify-content-center onboarding-header-brand">
          <Navbar.Brand
            href="https://www.sproutqr.com/"
            className="p-0 d-block d-lg-none"
          >
            <img
              className="logo"
              src={IMAGES.ONBOARDING_LOGO_MOBILE}
              alt="onboarding-logo"
              width="45"
              height="45"
            />
          </Navbar.Brand>
          <Navbar.Brand
            href="https://www.sproutqr.com/"
            className="p-0 d-none d-lg-block"
          >
            <img
              className="logo"
              src={IMAGES.ONBOARDING_LOGO}
              alt="onboarding-logo"
              width="291"
              height="85"
            />
          </Navbar.Brand>
        </Nav>
        <Nav.Link
          href="https://www.sproutqr.com/book-a-demo"
          target="blank"
          className="p-0 d-block d-lg-none"
        >
          <RippleButton customStyles="onboarding-header-button">
            Book Demo
          </RippleButton>
        </Nav.Link>
        <Navbar.Toggle
          aria-controls="onboarding-nav-reponsive"
          className="onboarding-header-toggle"
        >
          <img
            src={IMAGES.ONBOARDING_TOGGLE_ICON}
            alt="onboarding-toggle-icon"
            width="28"
            height="25"
          />
        </Navbar.Toggle>
        <Navbar.Collapse
          id="onboarding-nav-reponsive"
          className="align-items-center"
        >
          <Nav className="w-100 align-items-center justify-content-around">
            <Nav.Link
              className="onboarding-header-link onboarding-header-collapse"
              href="https://www.sproutqr.com/remediation-calculator"
              eventKey="1"
            >
              ADA Remediation
            </Nav.Link>
            <span className="onboarding-header-dot" />
            <Nav.Link
              className="onboarding-header-link onboarding-header-collapse"
              href="https://www.sproutqr.com/blog"
              eventKey="2"
            >
              Blog
            </Nav.Link>
            <span className="onboarding-header-dot" />
            <Nav.Link
              as={NavLink}
              to="/plans"
              className="onboarding-header-link onboarding-header-collapse"
              eventKey="3"
            >
              Pricing
            </Nav.Link>
            <span className="onboarding-header-dot" />
            <Nav.Link
              as={NavLink}
              to="/onboarding"
              className="onboarding-header-link"
              eventKey="4"
            >
              Buy Now
            </Nav.Link>
            <span className="onboarding-header-dot" />
            <Nav.Link
              className="onboarding-header-link"
              href="https://app.sproutqr.com/"
              eventKey="5"
            >
              Log In
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
        <Nav.Link
          href="https://www.sproutqr.com/book-a-demo"
          target="blank"
          className="p-0 d-none d-lg-block"
        >
          <RippleButton customStyles="onboarding-header-button">
            Book Demo
          </RippleButton>
        </Nav.Link>
      </Container>
    </Navbar>
  );
};

export default Header;
